const appName = 'Portunus';
export default appName;
